<template>
    <div v-if="!hide" class="form-network form-network-linkedin" >
        <details open>
            <summary>{{ $t('dash.post-creator.form.linkedin.survey') }} <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <div class="type-switch">
                    {{ $t('dash.post-creator.form.linkedin.add-survey') }}
                    <ComponentSwitch :value="formDataNetwork.survey.active" :onChange="(v)=>{formDataNetwork.survey.active = v, this.$emit('setFormDataNetwork', 'linkedin', this.formDataNetwork)}" :id="'switch-settings-advanced-linkedin-1'"></ComponentSwitch>
                </div>

                <div class="form-sondage" v-if="formDataNetwork.survey.active" >
                    <SelectComponent :changeValueSelect="changeDurationSurvey" :data="{oneDay:$t('dash.post-creator.form.linkedin.survey-duration-1day'),threeDay:$t('dash.post-creator.form.linkedin.survey-duration-3days'),oneWeek:$t('dash.post-creator.form.linkedin.survey-duration-1week'),twoWeek:$t('dash.post-creator.form.linkedin.survey-duration-2weeks')}" :valueSelect="formDataNetwork.survey.duration" :positionAuto="false" :positionX="'left'"></SelectComponent>
                    <div class="type-input">
                        <i class="fa-regular fa-circle-question"></i>
                        <input :placeholder="$t('dash.post-creator.form.linkedin.survey-question')" v-model="formDataNetwork.survey.question" maxlength="140"/>>
                    </div>

                    <div class="list-question">
                        <div class="type-input">
                            <input :placeholder="$t('dash.post-creator.form.linkedin.survey-option', { n: 1 })" v-model="formDataNetwork.survey.options[0]" maxlength="30"/>
                        </div>
                        <div class="type-input">
                            <input :placeholder="$t('dash.post-creator.form.linkedin.survey-option', { n: 2 })" v-model="formDataNetwork.survey.options[1]" maxlength="30"/>
                        </div>
                        <div class="type-input" v-if="formDataNetwork.survey.options.length >= 3">
                            <input :placeholder="$t('dash.post-creator.form.linkedin.survey-option', { n: 3 })" v-model="formDataNetwork.survey.options[2]" maxlength="30"/>
                            <i class="fa-regular fa-square-minus" @click="()=>removeOptionSurvey(2)"></i>
                        </div>

                        <div class="type-input" v-if="formDataNetwork.survey.options.length == 4">
                            <input :placeholder="$t('dash.post-creator.form.linkedin.survey-option', { n: 4 })" v-model="formDataNetwork.survey.options[3]" maxlength="30"/>
                            <i class="fa-regular fa-square-minus" @click="()=>removeOptionSurvey(3)"></i>
                        </div>

                        <div class="btn-add" v-if="formDataNetwork.survey.options.length < 4" @click="addOptionSurvey">
                            <p>{{ $t('dash.post-creator.form.linkedin.add-option') }}</p>
                            <i class="fa-solid fa-plus"></i>
                        </div>
                    </div>
                </div>

            </div>
        </details>

        <details>
            <summary>{{ $t('dash.post-creator.form.linkedin.visibility') }} <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <SelectComponent
                    :data="visibilityOptions"
                    :valueSelect="formDataNetwork.visibility || 'PUBLIC'"
                    :changeValueSelect="(v) => { formDataNetwork.visibility = v; $emit('setFormDataNetwork', 'linkedin', formDataNetwork) }"
                    :positionAuto="false"
                    :positionX="'left'"
                />
            </div>
        </details>


        <details>
            <summary>{{ $t('dash.post-creator.form.linkedin.targeting') }} <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">

                <!-- Sélecteur de page LinkedIn (multi-pages uniquement, hors mode personnalisation) -->
                <div v-if="showPageSelector" class="li-page-selector">
                    <SelectComponent
                        :data="linkedinPagesSelectData"
                        :valueSelect="selectedLinkedInPageId"
                        :changeValueSelect="(id) => { selectedLinkedInPageId = id }"
                        :positionAuto="false"
                        :positionX="'left'"
                    />
                </div>

                <div class="type-switch">
                    {{ $t('dash.post-creator.form.linkedin.targeting-enable') }}
                    <ComponentSwitch
                        :value="targetingActive"
                        :onChange="activateTargeting"
                        :id="'switch-linkedin-targeting'"
                    />
                </div>

                <div v-show="targetingActive" class="li-targeting-content">
                    <p class="li-info-msg">
                        <i class="fa-solid fa-triangle-exclamation"></i>
                        {{ $t('dash.post-creator.form.linkedin.targeting-min-followers') }}
                    </p>

                    <div class="li-criteria-list">

                        <!-- Langue -->
                        <div class="li-criterion" :class="{ 'li-criterion-open': activeDimension === 'interfaceLocales' }">
                            <div class="li-criterion-header" @click="toggleDimension('interfaceLocales')">
                                <span class="li-criterion-label">{{ $t('dash.post-creator.form.linkedin.targeting-locale') }}</span>
                                <template v-if="criterionChips('interfaceLocales')">
                                    <span class="li-criterion-chip" :class="criterionChips('interfaceLocales').mode" v-for="(lbl, i) in criterionChips('interfaceLocales').chips" :key="'loc-'+i">{{ lbl }}</span>
                                    <span class="li-criterion-badge" v-if="criterionChips('interfaceLocales').overflow > 0">{{ criterionChips('interfaceLocales').mode === 'exclude' ? '-' : '+' }}{{ criterionChips('interfaceLocales').overflow }}</span>
                                </template>
                                <i v-if="isCriterionLoading('interfaceLocales')" class="fa-solid fa-spinner fa-spin li-criterion-loading-icon"></i>
                                <i class="fa-solid fa-chevron-right li-criterion-arrow"></i>
                            </div>
                            <div class="li-criterion-content" v-show="activeDimension === 'interfaceLocales'">
                                <div v-if="isCriterionLoading('interfaceLocales')" class="li-options-loading">
                                    <i class="fa-solid fa-spinner fa-spin"></i>
                                </div>
                                <template v-else-if="currentFollowerStats.interfaceLocales && currentFollowerStats.interfaceLocales.length">
                                    <div class="list-radio-btn">
                                        <div class="type-btn-simple" :class="{ 'li-mode-active': currentTargeting && currentTargeting.interfaceLocales && currentTargeting.interfaceLocales.mode === 'include' }" @click.stop="setMode('interfaceLocales', 'include')">
                                            <i class="fa-solid fa-plus"></i> {{ $t('dash.post-creator.form.linkedin.targeting-include') }}
                                        </div>
                                        <div class="type-btn-simple" :class="{ 'li-mode-active': currentTargeting && currentTargeting.interfaceLocales && currentTargeting.interfaceLocales.mode === 'exclude' }" @click.stop="setMode('interfaceLocales', 'exclude')">
                                            <i class="fa-solid fa-minus"></i> {{ $t('dash.post-creator.form.linkedin.targeting-exclude') }}
                                        </div>
                                    </div>
                                    <div class="li-dim-list">
                                        <label class="li-dim-item" v-for="opt in filteredOptions('interfaceLocales')" :key="opt.value">
                                            <input type="checkbox" :checked="currentTargeting && currentTargeting.interfaceLocales && currentTargeting.interfaceLocales.values.includes(opt.value)" @change="toggleDimValue('interfaceLocales', opt.value)" />
                                            <span class="li-dim-item-label">{{ opt.label }}</span>
                                        </label>
                                    </div>
                                    <div class="list-tags" v-if="currentTargeting && currentTargeting.interfaceLocales && currentTargeting.interfaceLocales.values.length">
                                        <span class="tag" v-for="(val, i) in currentTargeting.interfaceLocales.values" :key="val">
                                            {{ dimLabelFor('interfaceLocales', val) }}
                                            <i class="fa-solid fa-xmark" @click.stop="removeDimValue('interfaceLocales', i)"></i>
                                        </span>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <!-- Géographie -->
                        <div class="li-criterion" :class="{ 'li-criterion-open': activeDimension === 'geoLocations' }">
                            <div class="li-criterion-header" @click="toggleDimension('geoLocations')">
                                <span class="li-criterion-label">{{ $t('dash.post-creator.form.linkedin.targeting-geo') }}</span>
                                <template v-if="criterionChips('geoLocations')">
                                    <span class="li-criterion-chip include" v-for="(lbl, i) in criterionChips('geoLocations').chips" :key="'geo-'+i">{{ lbl }}</span>
                                    <span class="li-criterion-badge" v-if="criterionChips('geoLocations').overflow > 0">+{{ criterionChips('geoLocations').overflow }}</span>
                                </template>
                                <i v-if="isCriterionLoading('geoLocations')" class="fa-solid fa-spinner fa-spin li-criterion-loading-icon"></i>
                                <i class="fa-solid fa-chevron-right li-criterion-arrow"></i>
                            </div>
                            <div class="li-criterion-content" v-show="activeDimension === 'geoLocations'">
                                <div v-if="isCriterionLoading('geoLocations')" class="li-options-loading">
                                    <i class="fa-solid fa-spinner fa-spin"></i>
                                    <span>Chargement...</span>
                                </div>
                                <template v-else-if="currentFollowerStats.geoList && currentFollowerStats.geoList.length">
                                    <div class="type-input" v-if="currentFollowerStats.geoList.length > 8">
                                        <i class="fa-solid fa-magnifying-glass"></i>
                                        <input type="text" v-model="geoFilter" placeholder="Filtrer..." />
                                    </div>
                                    <div class="li-dim-list">
                                        <label class="li-dim-item" v-for="item in filteredGeoList" :key="item.urn">
                                            <input type="checkbox" :checked="currentTargeting && currentTargeting.geoLocations && currentTargeting.geoLocations.values.includes(item.urn)" @change="toggleGeoItem(item)" />
                                            <span class="li-dim-item-label">{{ item.label }}</span>
                                            <span class="li-dim-item-count">{{ item.count }}</span>
                                        </label>
                                    </div>
                                    <p v-if="geoFollowerCount !== null" class="li-dim-follower-count">
                                        <i class="fa-solid fa-users"></i>
                                        {{ geoFollowerCount.toLocaleString() }} followers
                                    </p>
                                    <div class="list-tags" v-if="currentTargeting && currentTargeting.geoLocations && currentTargeting.geoLocations.values.length">
                                        <span class="tag" v-for="(urn, i) in currentTargeting.geoLocations.values" :key="urn">
                                            {{ geoLabelFor(urn) }}
                                            <i class="fa-solid fa-xmark" @click.stop="removeGeo(i)"></i>
                                        </span>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <!-- Autres dimensions -->
                        <div class="li-criterion" v-for="dim in targetingDimensions" :key="dim.key" :class="{ 'li-criterion-open': activeDimension === dim.key }">
                            <div class="li-criterion-header" @click="toggleDimension(dim.key)">
                                <span class="li-criterion-label">{{ $t('dash.post-creator.form.linkedin.' + dim.i18n) }}</span>
                                <template v-if="criterionChips(dim.key)">
                                    <span class="li-criterion-chip" :class="criterionChips(dim.key).mode" v-for="(lbl, i) in criterionChips(dim.key).chips" :key="dim.key+'-'+i">{{ lbl }}</span>
                                    <span class="li-criterion-badge" v-if="criterionChips(dim.key).overflow > 0">{{ criterionChips(dim.key).mode === 'exclude' ? '-' : '+' }}{{ criterionChips(dim.key).overflow }}</span>
                                </template>
                                <i v-if="isCriterionLoading(dim.key)" class="fa-solid fa-spinner fa-spin li-criterion-loading-icon"></i>
                                <i class="fa-solid fa-chevron-right li-criterion-arrow"></i>
                            </div>
                            <div class="li-criterion-content" v-show="activeDimension === dim.key">
                                <div v-if="isCriterionLoading(dim.key)" class="li-options-loading">
                                    <i class="fa-solid fa-spinner fa-spin"></i>
                                </div>
                                <template v-else-if="currentFollowerStats[dim.key] && currentFollowerStats[dim.key].length">
                                    <div class="list-radio-btn">
                                        <div class="type-btn-simple" :class="{ 'li-mode-active': currentTargeting && currentTargeting[dim.key] && currentTargeting[dim.key].mode === 'include' }" @click.stop="setMode(dim.key, 'include')">
                                            <i class="fa-solid fa-plus"></i> {{ $t('dash.post-creator.form.linkedin.targeting-include') }}
                                        </div>
                                        <div class="type-btn-simple" :class="{ 'li-mode-active': currentTargeting && currentTargeting[dim.key] && currentTargeting[dim.key].mode === 'exclude' }" @click.stop="setMode(dim.key, 'exclude')">
                                            <i class="fa-solid fa-minus"></i> {{ $t('dash.post-creator.form.linkedin.targeting-exclude') }}
                                        </div>
                                    </div>
                                    <div class="type-input" v-if="currentFollowerStats[dim.key].length > 8">
                                        <i class="fa-solid fa-magnifying-glass"></i>
                                        <input type="text" v-model="dimFilter[dim.key]" placeholder="Filtrer..." />
                                    </div>
                                    <div class="li-dim-list">
                                        <label class="li-dim-item" v-for="opt in filteredOptions(dim.key)" :key="opt.value">
                                            <input type="checkbox" :checked="currentTargeting && currentTargeting[dim.key] && currentTargeting[dim.key].values.includes(opt.value)" @change="toggleDimValue(dim.key, opt.value)" />
                                            <span class="li-dim-item-label">{{ opt.label }}</span>
                                            <span v-if="opt.count !== null" class="li-dim-item-count">{{ opt.count }}</span>
                                        </label>
                                    </div>
                                    <p v-if="dimFollowerCount(dim.key) !== null" class="li-dim-follower-count">
                                        <i class="fa-solid fa-users"></i>
                                        {{ dimFollowerCount(dim.key).toLocaleString() }} followers
                                    </p>
                                    <div class="list-tags" v-if="currentTargeting && currentTargeting[dim.key] && currentTargeting[dim.key].values.length">
                                        <span class="tag" v-for="(val, i) in currentTargeting[dim.key].values" :key="val">
                                            {{ dimLabelFor(dim.key, val) }}
                                            <i class="fa-solid fa-xmark" @click.stop="removeDimValue(dim.key, i)"></i>
                                        </span>
                                    </div>
                                </template>
                            </div>
                        </div>

                    </div>

                    <!-- Validation audience -->
                    <div class="li-targeting-section li-validate-audience">
                        <button
                            class="type-btn-simple"
                            :disabled="!hasAnyCriteria || audienceValidating"
                            @click="validateAudience"
                        >
                            <i v-if="audienceValidating" class="fa-solid fa-spinner fa-spin"></i>
                            <i v-else class="fa-solid fa-users-viewfinder"></i>
                            {{ $t('dash.post-creator.form.linkedin.targeting-validate') }}
                        </button>
                        <p v-if="audienceTotal !== null && audienceTotal > 0" class="li-audience-ok">
                            <i class="fa-solid fa-circle-check"></i>
                            {{ $t('dash.post-creator.form.linkedin.targeting-valid', { n: audienceTotal.toLocaleString() }) }}
                        </p>
                        <p v-else-if="audienceTotal !== null && audienceTotal === 0" class="li-audience-ko">
                            <i class="fa-solid fa-circle-xmark"></i>
                            {{ $t('dash.post-creator.form.linkedin.targeting-invalid') }}
                        </p>
                        <p v-else-if="audienceError" class="li-audience-ko">
                            <i class="fa-solid fa-triangle-exclamation"></i>
                            Erreur lors de la vérification
                        </p>
                        <p v-if="audienceStaffIgnored && audienceTotal !== null" class="li-audience-info">
                            <i class="fa-solid fa-circle-info"></i>
                            {{ $t('dash.post-creator.form.linkedin.targeting-staff-ignored') }}
                        </p>
                    </div>
                </div>
            </div>
        </details>

        <details v-if="!formDataNetwork.survey.active && formData.urlsTextContentHistory.length" open>
            <summary>{{ $t('dash.post-creator.form.linkedin.link-preview') }} <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail form-link">
                <div class="list-thubmmail">
                    <div class="thubmmail" v-for="(url) in this.formData.urlsTextContentHistory" @click="()=>selectUrl(url)" :key="url">
                        <Checkbox :id="url" :prefixId="'thubmmail-'"
                            :isChecked="(formDataNetwork.snippet.link == url)"
                            :isDisable="(formDataNetwork.snippet.link == url)"
                            :add="selectUrl" :remove="()=>{}"
                        />
                        <SnippetNetwork
                            :link="url"
                            :isDisable="(formDataNetwork.snippet.link == url)"
                            :imageUrlDefault="formDataNetwork.snippet.customActived && formDataNetwork.snippet.image && formDataNetwork.snippet.image.id && files[formDataNetwork.snippet.image.id].isUpload ? files[formDataNetwork.snippet.image.id].url : undefined"
                            :titleDefault="formDataNetwork.snippet.customActived && formDataNetwork.snippet.title"
                        />
                    </div>
                </div>

                <!-- Beta url_shortener : l'aperçu se personnalise dans la section commune du post creator (LinkPreviewCustom.vue) -->
                <p class="link-preview-unified-hint" v-if="linkPreviewUnified && formData.urlsTextContentHistory.length">
                    <i class="fa-solid fa-circle-info"></i> {{ $t('dash.post-creator.short-link-og.linkedin-hint') }}
                </p>

                <div class="type-switch"  v-if="!linkPreviewUnified && formData.urlsTextContentHistory.length">
                    {{ $t('dash.post-creator.form.linkedin.link-preview-edit') }}
                    <ComponentSwitch :value="formDataNetwork.snippet.customActived" :onChange="(v) => switchCustomSnippetChange(v)" :id="'switch-settings-advanced-linkedin-2'"></ComponentSwitch>
                </div>

                <template v-if="!linkPreviewUnified && formDataNetwork.snippet.customActived && (formData.urlsTextContentHistory.length)">
                    <input
                        v-validate="''"
                        name="file"
                        type="file"
                        id="file"
                        ref="inputImageSnippet"
                        @change="selectImageSnippet"
                        :multiple="false"
                        @click="()=>{}"
                        :accept="`image/*`"
                        hidden
                    >

                    <div class="type-btn-add" @click="toggleAddImage">
                        <i class="fa-solid fa-image"></i>
                        <template v-if="
                            formDataNetwork.snippet.image &&
                            formDataNetwork.snippet.title.id &&
                            files[formDataNetwork.snippet.image.id] &&
                            files[formDataNetwork.snippet.image.id].uploadProgress &&
                            !files[formDataNetwork.snippet.image.id].failedUpload
                        ">
                            {{ $t('dash.post-creator.form.linkedin.media-uploading') }}
                        </template>
                        <template v-else-if="
                            formDataNetwork.snippet.image &&
                            formDataNetwork.snippet.image.id &&
                            files[formDataNetwork.snippet.image.id] &&
                            files[formDataNetwork.snippet.image.id].isUpload
                        ">
                            {{files[formDataNetwork.snippet.image.id].info.name}}
                             <i class="fa-regular fa-square-minus"></i>
                        </template>
                        <template v-else>
                            {{ $t('dash.post-creator.form.linkedin.add-image') }}
                            <i class="fa-solid fa-plus"></i>
                        </template>
                    </div>
                    <div class="type-input">
                        <i class="fa-solid fa-pen-to-square"></i>
                        <input placeholder="Titre par default" v-model="formDataNetwork.snippet.title">
                        <i class="fa-regular fa-square-minus" v-if="formDataNetwork.snippet.title" @click="()=> formDataNetwork.snippet.title =''"></i>
                    </div>
                </template>
            </div>

        </details>
   </div>
</template>

<script>
   import { EventBus } from '@/event-bus';
   import store from '@/store/index.js';
   import ComponentSwitch from '@/components/dash/utils/switch.vue'
   import SelectComponent from '@/components/dash/utils/select.vue'
   import SnippetNetwork from './../SnippetNetwork.vue'
   import minxinBot from '@/components/mixins/Bots.vue'
   import minxinPost from '@/components/mixins/Posts.vue'
   import Checkbox from '@/components/dash/utils/checkbox.vue'
   import { getFilesByNetwork } from './../../../utils'
   import { linkPreviewUnified } from './../../../linkPreview.js'

   const defaultTargeting = () => ({
       active: false,
       geoLocations: { values: [] },
       seniorities: { mode: 'include', values: [] },
       industries: { mode: 'include', values: [] },
       jobFunctions: { mode: 'include', values: [] },
       interfaceLocales: { mode: 'include', values: [] },
       staffCountRanges: { mode: 'include', values: [] },
   })

   export default {

       components: {
           ComponentSwitch,
           SelectComponent,
           SnippetNetwork,
           Checkbox
       },
       mixins: [minxinBot, minxinPost],

       props: {
            hide : {
                type: Boolean,
                default: false
            },
            formData: {
                type: Object,
                default: () => ({})
            },

            formDataNetwork: {
                type: Object,
                default: () => ({})
            },

            files: Object,

            personalizationMode : {
                type: Boolean,
                default: false
            },
            idPageRenderNetworkSelected: String,
            typeRenderNetworkSelected: String,
       },

       data() {
           return {
                inputModel:{
                    urlImageSnippet: "",
                    titleSnippet: "",
                    descriptionSnippet: "",
                },

                lastModeSelected : undefined,

                // Visibility
                visibilityOptions: {
                    PUBLIC: 'Public',
                    CONNECTIONS: 'Connexions',
                    LOGGED_IN: 'Membres LinkedIn',
                },


                // Multi-page selector
                selectedLinkedInPageId: null,

                // Targeting
                targetingDimensions: [
                    { key: 'seniorities',      i18n: 'targeting-seniority' },
                    { key: 'industries',        i18n: 'targeting-industry' },
                    { key: 'jobFunctions',      i18n: 'targeting-function' },
                    { key: 'staffCountRanges',  i18n: 'targeting-company-size' },
                ],
                dimFilter: { seniorities: '', industries: '', jobFunctions: '', interfaceLocales: '', staffCountRanges: '' },

                // Miroir local pour le toggle — évite le lag du round-trip prop
                targetingActive: false,
                activeDimension: null,

                // Validation audience
                audienceValidating: false,
                audienceTotal: null,
                audienceError: null,
                audienceStaffIgnored: false,

                // Geo filter
                geoFilter: '',

                // Follower stats indexés par pageId
                followerStatsByPage: {},
                dimensionLoadingKeys: {},
           }
       },

       mounted() {
            if (this.formData.formDataNetwork.linkedin) this.formDataNetwork = this.formData.formDataNetwork.linkedin
            if (!this.formDataNetwork.visibility)
                this.$set(this.formDataNetwork, 'visibility', 'PUBLIC')
            if (!this.formDataNetwork.targetingByPage)
                this.$set(this.formDataNetwork, 'targetingByPage', {})

            // Initialise le sélecteur sur la première page LinkedIn
            const liPages = this.linkedinPagesSelected
            if (liPages.length > 0) {
                this.selectedLinkedInPageId = liPages[0].id
            }

            // Initialise targetingByPage pour chaque page (migration depuis ancien format 'targeting')
            for (const page of liPages) {
                if (!this.formDataNetwork.targetingByPage[page.id]) {
                    const old = this.formDataNetwork.targeting
                    this.$set(this.formDataNetwork.targetingByPage, page.id,
                        (old && old.active) ? { ...old } : defaultTargeting()
                    )
                }
            }

            this.targetingActive = !!(this.currentTargeting && this.currentTargeting.active)

            // Charge les stats pour les pages dont le ciblage est déjà actif
            for (const page of liPages) {
                const t = this.formDataNetwork.targetingByPage[page.id]
                if (t && t.active) this.loadAllDimensions(page.id)
            }
       },

       methods: {
            initTargetingForPage(pageId) {
                if (!this.formDataNetwork.targetingByPage)
                    this.$set(this.formDataNetwork, 'targetingByPage', {})
                if (!this.formDataNetwork.targetingByPage[pageId])
                    this.$set(this.formDataNetwork.targetingByPage, pageId, defaultTargeting())
            },

            toggleDimension(key) {
                this.activeDimension = this.activeDimension === key ? null : key
            },

            activateTargeting(v) {
                if (!this.currentPageId) return
                this.initTargetingForPage(this.currentPageId)
                this.targetingActive = v
                this.$set(this.formDataNetwork.targetingByPage[this.currentPageId], 'active', v)
                this.$emit('setFormDataNetwork', 'linkedin', this.formDataNetwork)
                if (v) this.loadAllDimensions(this.currentPageId)
            },

            addMode(mode) {
                this.lastModeSelected = mode
                EventBus.$emit("postCreatorAddMode", mode);
            },

            detectTypeContent() {
                console.log("detectTypeContent linkedin")
                if(this.formData.files.length) {
                    try {
                        const typeAccepted = ['video', 'image']
                        if (this.conciergeriePagesIsActive) {
                            typeAccepted.push('pdf')
                        }
                        const typeMedia = this.files[this.formData.files.find(f => this.files[f.id] && typeAccepted.includes(this.files[f.id].info.type2)).id].info.type2
                        console.log("detectTypeContent linkedin",typeAccepted, typeMedia)
                        this.formDataNetwork.typeMedia = typeMedia
                        this.$emit('setFormDataNetwork', 'linkedin', this.formDataNetwork)
                    } catch (error) {
                        this.formDataNetwork.typeMedia = 'image'
                        console.error("Impossible de détecter le type des médias. formLinkedin.vue/detectTypeContent")
                    }
                }
            },

            addOptionSurvey() {
                this.formDataNetwork.survey.options = [...this.formDataNetwork.survey.options, ''].slice(0,4)
                this.$emit('setFormDataNetwork', 'linkedin', this.formDataNetwork)
            },

            removeOptionSurvey(index) {
                this.formDataNetwork.survey.options = this.formDataNetwork.survey.options.filter((o,i) => i !== index)
                this.$emit('setFormDataNetwork', 'linkedin', this.formDataNetwork)
            },

            changeDurationSurvey(duration) {
                this.formDataNetwork.survey.duration = duration
                this.$emit('setFormDataNetwork', 'linkedin', this.formDataNetwork)
            },

            switchCustomSnippetChange(v) {
                this.$set(this.formDataNetwork.snippet, 'customActived', v)
                this.$emit('setFormDataNetwork', 'linkedin', this.formDataNetwork)
            },

            selectUrl(url) {
                if (!this.formDataNetwork.snippet) this.formDataNetwork.snippet = {}
                this.formDataNetwork.snippet.link = this.formDataNetwork.snippet.link == url ? '' : url
                this.$emit('setFormDataNetwork', 'linkedin', this.formDataNetwork)
            },

            verifUrlSelected(urlsTextContentHistory = []) {
                urlsTextContentHistory = this.formData.urlsTextContentHistory
                if (urlsTextContentHistory.length) {
                    let linkSelect = this.formDataNetwork && this.formDataNetwork.snippet && this.formDataNetwork.snippet.link ? this.formDataNetwork.snippet.link : null
                    if (!linkSelect) {
                        const files = getFilesByNetwork(this.formData.files, ['linkedin'], {['linkedin']: this.formData.formDataNetwork['linkedin']}, this.files, true)['linkedin']
                        if (!files || !files.length) {
                            this.selectUrl(urlsTextContentHistory[0])
                        }
                    }else if (!urlsTextContentHistory.includes(linkSelect)) {
                        this.selectUrl(urlsTextContentHistory[0])
                    }
                }else{
                    this.selectUrl('')
                }
            },

            toggleAddImage() {
                if (this.formDataNetwork.snippet.image == undefined) {
                    this.$refs.inputImageSnippet.click()
                }else{
                    this.$set(this.formDataNetwork.snippet, 'image', undefined)
                }
            },

            selectImageSnippet(e) {
                const newFileId = Math.random().toString(36).substr(2, 9)
                this.$set(this.formDataNetwork.snippet, 'image', { id: newFileId })
                EventBus.$emit('postcreator/uploadFile', null, e.target.files[0], true, newFileId)
                this.$emit('saveFormData')
            },

            fileAdded() {
                console.log("fileAdded formLinkedin.vue", this.formData.files.length)
                this.detectTypeContent()
                if (this.formData.files.length >= 1) {
                    this.selectUrl('')
                }
            },

            filteredOptions(dimKey) {
                const list = (this.currentFollowerStats && this.currentFollowerStats[dimKey]) || []
                const f = (this.dimFilter[dimKey] || '').toLowerCase()
                return f ? list.filter(o => o.label.toLowerCase().includes(f)) : list
            },

            dimLabelFor(dimKey, value) {
                const list = (this.currentFollowerStats && this.currentFollowerStats[dimKey]) || []
                const item = list.find(o => o.value === value)
                return item ? item.label : value
            },

            criterionChips(dimKey) {
                if (!this.currentTargeting) return null
                const cfg = this.currentTargeting[dimKey]
                if (!cfg || !cfg.values || !cfg.values.length) return null
                const MAX = 2
                const values = cfg.values
                const mode = cfg.mode || 'include'
                let labels
                if (dimKey === 'geoLocations') {
                    const geoList = (this.currentFollowerStats && this.currentFollowerStats.geoList) || []
                    labels = values.map(urn => {
                        const item = geoList.find(g => g.urn === urn)
                        return item ? item.label : urn
                    })
                } else {
                    const list = (this.currentFollowerStats && this.currentFollowerStats[dimKey]) || []
                    labels = values.map(v => {
                        const item = list.find(o => o.value === v)
                        return item ? item.label : v
                    })
                }
                return { chips: labels.slice(0, MAX), overflow: Math.max(0, values.length - MAX), mode }
            },

            removeDimValue(dimKey, index) {
                if (!this.currentTargeting || !this.currentTargeting[dimKey]) return
                this.currentTargeting[dimKey].values.splice(index, 1)
                this.$emit('setFormDataNetwork', 'linkedin', this.formDataNetwork)
            },

            setMode(dimKey, mode) {
                if (!this.currentTargeting || !this.currentTargeting[dimKey]) return
                this.$set(this.currentTargeting[dimKey], 'mode', mode)
                this.$emit('setFormDataNetwork', 'linkedin', this.formDataNetwork)
            },

            toggleDimValue(dimKey, value) {
                if (!this.currentTargeting || !this.currentTargeting[dimKey]) return
                const arr = this.currentTargeting[dimKey].values
                const idx = arr.indexOf(value)
                const next = idx >= 0 ? arr.filter((_, i) => i !== idx) : [...arr, value]
                this.$set(this.currentTargeting[dimKey], 'values', next)
                this.$emit('setFormDataNetwork', 'linkedin', this.formDataNetwork)
            },

            toggleGeoItem(item) {
                if (!this.currentTargeting || !this.currentTargeting.geoLocations) return
                const values = this.currentTargeting.geoLocations.values
                const idx = values.indexOf(item.urn)
                const next = idx >= 0 ? values.filter((_, i) => i !== idx) : [...values, item.urn]
                this.$set(this.currentTargeting.geoLocations, 'values', next)
                this.$emit('setFormDataNetwork', 'linkedin', this.formDataNetwork)
            },

            geoLabelFor(urn) {
                const geoList = this.currentFollowerStats && this.currentFollowerStats.geoList
                if (!geoList) return urn
                const item = geoList.find(g => g.urn === urn)
                return item ? item.label : urn
            },

            removeGeo(index) {
                if (!this.currentTargeting || !this.currentTargeting.geoLocations) return
                this.currentTargeting.geoLocations.values.splice(index, 1)
                this.$emit('setFormDataNetwork', 'linkedin', this.formDataNetwork)
            },

            loadAllDimensions(pageId) {
                if (!pageId) return
                const dims = ['interfaceLocales', 'geoLocations', 'seniorities', 'industries', 'jobFunctions', 'staffCountRanges']
                dims.forEach(dim => this.loadFollowerStats(pageId, dim))
            },

            async loadFollowerStats(pageId, dimension) {
                if (!pageId || !dimension) return
                const key = `${pageId}:${dimension}`
                if (this.dimensionLoadingKeys[key] || (this.followerStatsByPage[pageId] && this.followerStatsByPage[pageId][dimension === 'geoLocations' ? 'geoList' : dimension] !== undefined)) return
                this.$set(this.dimensionLoadingKeys, key, true)
                try {
                    const { body } = await this.$http.get(
                        `${process.env.VUE_APP_API_HOST}/linkedin/targeting/followerStats?pageId=${pageId}&dimension=${dimension}`,
                        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
                    )
                    const data = (body && body.data) ? body.data : body || {}
                    if (!this.followerStatsByPage[pageId]) this.$set(this.followerStatsByPage, pageId, {})
                    for (const k of Object.keys(data)) this.$set(this.followerStatsByPage[pageId], k, data[k])
                } catch (e) {
                    console.error('loadFollowerStats', dimension, e)
                } finally {
                    this.$set(this.dimensionLoadingKeys, key, false)
                }
            },

            isCriterionLoading(key) {
                return !!this.dimensionLoadingKeys[`${this.currentPageId}:${key}`]
            },

            dimFollowerCount(dimKey) {
                const list = (this.currentFollowerStats && this.currentFollowerStats[dimKey]) || []
                if (!list.length) return null
                const hasCount = list.some(item => item.count != null)
                if (!hasCount) return null
                const cfg = this.currentTargeting && this.currentTargeting[dimKey]
                if (!cfg || !cfg.values || !cfg.values.length) return null
                if (cfg.mode === 'exclude') {
                    const total = list.reduce((sum, item) => sum + (item.count || 0), 0)
                    const selected = list.filter(item => cfg.values.includes(item.value)).reduce((sum, item) => sum + (item.count || 0), 0)
                    return total - selected
                }
                return list.filter(item => cfg.values.includes(item.value)).reduce((sum, item) => sum + (item.count || 0), 0)
            },

            async validateAudience() {
                if (!this.currentPageId || !this.currentTargeting) return
                this.audienceValidating = true
                this.audienceError = null
                try {
                    const targeting = encodeURIComponent(JSON.stringify(this.currentTargeting))
                    const { body } = await this.$http.get(
                        `${process.env.VUE_APP_API_HOST}/linkedin/targeting/validate?pageId=${this.currentPageId}&targeting=${targeting}`,
                        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
                    )
                    if (!body || body.success === false) {
                        this.audienceError = 'error'
                        return
                    }
                    const raw = (body && body.data !== undefined) ? body.data : body || {}
                    this.audienceTotal = raw.total !== undefined ? raw.total : null
                    this.audienceStaffIgnored = !!raw.staffCountRangesIgnored
                } catch (e) {
                    console.error('validateAudience', e)
                    this.audienceError = 'error'
                } finally {
                    this.audienceValidating = false
                }
            },
       },

       computed: {
            linkPreviewUnified() {
                return linkPreviewUnified()
            },

            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },

            linkedinPagesSelected() {
                return this.pagesSelected.filter(p => p && p.network === 'linkedin')
            },

            showPageSelector() {
                const isNetworkPersonalization = this.personalizationMode && !this.idPageRenderNetworkSelected
                return (!this.personalizationMode || isNetworkPersonalization) && this.linkedinPagesSelected.length > 1
            },

            linkedinPagesSelectData() {
                return Object.fromEntries(this.linkedinPagesSelected.map(p => [p.id, p.name]))
            },

            currentPageId() {
                if (this.personalizationMode && this.idPageRenderNetworkSelected) return this.idPageRenderNetworkSelected
                return this.selectedLinkedInPageId || (this.linkedinPagesSelected[0] || {}).id
            },

            currentTargeting() {
                return (this.formDataNetwork.targetingByPage && this.formDataNetwork.targetingByPage[this.currentPageId]) || null
            },

            currentFollowerStats() {
                return this.followerStatsByPage[this.currentPageId] || {}
            },

            currentFollowerStatsLoading() {
                if (!this.currentPageId) return false
                const dims = ['interfaceLocales', 'geoLocations', 'seniorities', 'industries', 'jobFunctions', 'staffCountRanges']
                return dims.some(d => this.dimensionLoadingKeys[`${this.currentPageId}:${d}`])
            },

            filteredGeoList() {
                const list = (this.currentFollowerStats && this.currentFollowerStats.geoList) || []
                const f = (this.geoFilter || '').toLowerCase()
                return f ? list.filter(g => g.label.toLowerCase().includes(f)) : list
            },

            geoFollowerCount() {
                const stats = this.currentFollowerStats.geoLocations
                if (!stats || !Object.keys(stats).length) return null
                const values = this.currentTargeting && this.currentTargeting.geoLocations && this.currentTargeting.geoLocations.values
                if (!values || !values.length) return null
                const hasMatch = values.some(urn => stats[urn] != null)
                if (!hasMatch) return null
                return values.reduce((sum, urn) => sum + (stats[urn] || 0), 0)
            },

            hasAnyCriteria() {
                const t = this.currentTargeting
                if (!t) return false
                if (t.geoLocations && t.geoLocations.values && t.geoLocations.values.length) return true
                return ['seniorities', 'industries', 'jobFunctions', 'interfaceLocales', 'staffCountRanges']
                    .some(k => t[k] && t[k].values && t[k].values.length)
            },


            conciergeriePagesIsActive() {
                const pagesLinkedin = this.pagesSelected.filter(page => page.network == 'linkedin')
                const isActive = (page) => {
                    return (page.network == 'linkedin' && page.story_config && page.story_config.created)
                }
                if (!this.personalizationMode || !this.idPageRenderNetworkSelected) {
                    return pagesLinkedin.every(page => isActive(page))
                }else{
                    return isActive(this.allPages[this.idPageRenderNetworkSelected])
                }
            },
       },

       watch: {
            selectedLinkedInPageId(newId) {
                if (!newId) return
                this.initTargetingForPage(newId)
                this.targetingActive = !!(this.formDataNetwork.targetingByPage[newId] && this.formDataNetwork.targetingByPage[newId].active)
                if (this.targetingActive) this.loadAllDimensions(newId)
            },

            ['formData.formDataNetwork.linkedin']() {
                if (this.formData.formDataNetwork.linkedin) {
                    this.formDataNetwork = this.formData.formDataNetwork.linkedin
                    if (!this.formDataNetwork.visibility)
                        this.$set(this.formDataNetwork, 'visibility', 'PUBLIC')
                    if (!this.formDataNetwork.targetingByPage)
                        this.$set(this.formDataNetwork, 'targetingByPage', {})
                    this.targetingActive = !!(this.currentTargeting && this.currentTargeting.active)
                }
            },
            'formData.urlsTextContentHistory'(newValue) {
                this.verifUrlSelected()
            },

            conciergeriePagesIsActive: {
                immediate: true,
                handler(newValue, oldValue) {
                    this.detectTypeContent()
                }
            },

            ['formDataNetwork.survey.options']() {
                this.$emit('setFormDataNetwork', 'linkedin', this.formDataNetwork)
            },
            ['formDataNetwork.survey.question']() {
                this.$emit('setFormDataNetwork', 'linkedin', this.formDataNetwork)
            },
            ['formDataNetwork.snippet.title']() {
                this.$emit('setFormDataNetwork', 'linkedin', this.formDataNetwork)
            },

            currentTargeting: {
                deep: true,
                handler() {
                    this.audienceTotal = null
                    this.audienceError = null
                }
            },
       },

       beforeDestroy () {}

   }
</script>

<style scoped>
.link-preview-unified-hint {
    margin: 8px 0 0;
    font-size: 12px;
    color: #9FA4A8;
}

/* ---- Page selector ---- */
.li-page-selector {
    margin-bottom: 10px;
}

/* ---- Container des sections de ciblage ---- */
.li-targeting-content {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 10px;
}

/* ---- Accordéon critères ---- */
.li-criteria-list {
    border: 1.2px solid #F1EDF5;
    border-radius: 10px;
    overflow: hidden;
}

.li-criterion {
    border-bottom: 1.2px solid #F1EDF5;
}

.li-criterion:last-child {
    border-bottom: none;
}

.li-criterion-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    cursor: pointer;
    transition: background 0.12s;
    user-select: none;
}

.li-criterion-header:hover {
    background: #FAF7FC;
}

.li-criterion-open > .li-criterion-header {
    background: #F1EDF5;
}

.li-criterion-label {
    flex: 1;
    font-size: 12px;
    font-weight: 600;
    color: #121826;
}

.li-criterion-chip {
    font-size: 10px;
    font-weight: 500;
    padding: 2px 7px;
    border-radius: 20px;
    white-space: nowrap;
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
    background-color: #EDE4F3;
    color: #6B1F4D;
}

.li-criterion-chip.exclude {
    background-color: #FCE8F0;
    color: #8B1A3C;
}

.li-criterion-badge {
    font-size: 10px;
    font-weight: 700;
    background: #B64985;
    color: #fff;
    border-radius: 10px;
    padding: 1px 7px;
    line-height: 16px;
    flex-shrink: 0;
}

.li-criterion-arrow {
    font-size: 10px;
    color: #AB6E93;
    transition: transform 0.2s;
    flex-shrink: 0;
}

.li-criterion-loading-icon {
    font-size: 10px;
    color: #AB6E93;
    flex-shrink: 0;
}

.li-criterion-open > .li-criterion-header .li-criterion-arrow {
    transform: rotate(90deg);
}

.li-criterion-content {
    padding: 12px 14px;
    border-top: 1.2px solid #F1EDF5;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

/* ---- Targeting sections (validate row) ---- */
.li-targeting-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

/* ---- Tag list (reuse existing .list-tags pattern) ---- */
.list-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    width: 100%;
}

.list-tags .tag {
    background-color: #b64985;
    border-radius: 6px;
    display: flex;
    align-items: center;
    gap: 5px;
    height: 25px;
    padding: 0 8px;
    color: #fff;
    font-size: 12px;
    font-weight: 500;
    cursor: default;
}

.list-tags .tag i {
    font-size: 11px;
    cursor: pointer;
    opacity: 0.8;
}

.list-tags .tag i:hover {
    opacity: 1;
}

/* ---- Mode toggle (segmented control compact) ---- */
.list-radio-btn {
    gap: 0 !important;
    display: inline-flex !important;
}

.list-radio-btn .type-btn-simple {
    height: 24px !important;
    font-size: 11px !important;
    padding: 0 9px !important;
    gap: 4px !important;
    border-radius: 0 !important;
    border-right-width: 0 !important;
}

.list-radio-btn .type-btn-simple i {
    font-size: 10px !important;
    width: auto !important;
    height: auto !important;
}

.list-radio-btn .type-btn-simple:first-child {
    border-radius: 5px 0 0 5px !important;
}

.list-radio-btn .type-btn-simple:last-child {
    border-radius: 0 5px 5px 0 !important;
    border-right-width: 1.2px !important;
}

.list-radio-btn .type-btn-simple.li-mode-active {
    background-color: #6B1F4D;
    color: #fff !important;
    border-color: #6B1F4D !important;
}

.list-radio-btn .type-btn-simple.li-mode-active i {
    color: #fff !important;
}

/* ---- Dimension checklist ---- */
.li-dim-list {
    max-height: 180px;
    overflow-y: auto;
    border: 1.2px solid #F1EDF5;
    border-radius: 10px;
    padding: 6px 0;
    display: flex;
    flex-direction: column;
}

.li-dim-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 5px 12px;
    font-size: 12px;
    color: #555E75;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.12s;
}

.li-dim-item:hover {
    background: #F1EDF5;
}

.li-dim-item input[type="checkbox"] {
    accent-color: #B64985;
    width: 13px;
    height: 13px;
    flex-shrink: 0;
    cursor: pointer;
}

.li-dim-item-label {
    flex: 1;
}

.li-dim-item-count {
    margin-left: auto;
    font-size: 10px;
    color: #AB6E93;
    font-weight: 500;
    white-space: nowrap;
}

/* ---- Options global loader ---- */
.li-options-loading {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #AB6E93;
    padding: 10px 0;
}

.li-options-loading i {
    font-size: 14px;
}

/* ---- Follower count per dimension ---- */
.li-dim-follower-count {
    font-size: 11px;
    color: #AB6E93;
    display: flex;
    align-items: center;
    gap: 5px;
    margin: 2px 0 0 0;
}

.li-dim-follower-count i {
    font-size: 11px;
}

/* ---- Loading / info ---- */
.li-loading {
    color: #AB6E93;
    font-size: 13px;
    text-align: center;
    padding: 6px 0;
    margin: 0;
}

.li-info-msg {
    font-size: 12px;
    color: #555E75;
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 0;
}

.li-info-msg i {
    color: #f0a000;
    font-size: 13px;
}

/* ---- Audience result ---- */
.li-audience-ok,
.li-audience-ko {
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 0;
}

.li-audience-ok { color: #27a65a; }
.li-audience-ko { color: #e0394a; }
.li-audience-info { color: #7a5c9e; }

.li-audience-ok i { color: #27a65a; }
.li-audience-ko i { color: #e0394a; }
.li-audience-info i { color: #7a5c9e; }
</style>
